import { render, staticRenderFns } from "./ContentNameList.vue?vue&type=template&id=208ed72a&scoped=true&"
import script from "./ContentNameList.vue?vue&type=script&lang=js&"
export * from "./ContentNameList.vue?vue&type=script&lang=js&"
import style0 from "./ContentNameList.vue?vue&type=style&index=0&id=208ed72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208ed72a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
